import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";
import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";

import { InadimplenciaCadastroComponent } from "./cadastro/inadimplencia-cadastro.component";
import { InadimplenciaPesquisaComponent } from "./pesquisa/inadimplencia-pesquisa.component";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";

const routes:Routes = [
    {
        path: 'inadimplencia/pesquisa',
        component: InadimplenciaPesquisaComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
        data: { canReuse: false }
    },
    {
        path:'inadimplencia/:id',
        component: InadimplenciaCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
        data: { canReuse: false }
    },
    {
        path:'inadimplencia',
        component: InadimplenciaCadastroComponent,
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        canDeactivate: [CanDeactivateGuardService],
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
        data: { canReuse: false }
    },
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class InadimplenciaRoutingModule{}
